<template>
  <div>
    <el-table size="medium" stripe :data="invitations" style="width: 100%">
      <!--  -->
      <el-table-column align="center" label="#" width="60">
        <template #default="scope">
          <el-tooltip :content="scope.row._id">
            <i f-w-700 class="el-icon-position"></i>
          </el-tooltip>
        </template>
      </el-table-column>
      <!--  -->
      <!--  -->
      <!-- Invitation type -->
      <el-table-column align="center" label="Type" width="270">
        <template #default="scope">
          <el-tag
            :type="
              scope.row.type === 'admin'
                ? 'danger'
                : scope.row.type === 'talent'
                ? 'info'
                : 'success'
            "
            effect="dark"
            is-rounded
            size="mini"
          >
            {{ $filters.capitalize(scope.row.type) }}
          </el-tag>
        </template>
      </el-table-column>
      <!--  -->
      <!-- Invitation Status -->
      <el-table-column align="center" label="Status" width="270">
        <template #default="scope">
          <el-tag
            :type="
              scope.row.status === 'accepted'
                ? 'success'
                : scope.row.status === 'denied'
                ? 'danger'
                : 'info'
            "
            effect="dark"
            is-rounded
            size="mini"
          >
            {{ $filters.capitalize(scope.row.status) }}
          </el-tag>
        </template>
      </el-table-column>
      <!--  -->
      <!-- Email -->
      <el-table-column label="Email" width="350">
        <template #default="scope">
          <el-link
            type="primary"
            :href="`mailto:${scope.row.email}`"
            size="mini"
          >
            {{ scope.row.email }}
          </el-link>
        </template>
      </el-table-column>
      <!--  -->
      <!--  -->
      <!-- Created AT -->
      <el-table-column label="Created At" align="left" width="250">
        <template #default="scope">
          <small mute-secondary>
            {{ $filters.capitalize($moment(scope.row.createdAt).fromNow()) }}
          </small>
        </template>
      </el-table-column>
      <!--  -->
      <!-- Actions -->
      <el-table-column align="center" label="...">
        <template #default>
          <el-button icon="el-icon-delete" size="mini" />
        </template>
      </el-table-column>
      <!--  -->
    </el-table>
  </div>
</template>

<script lang="ts">
import { User } from "@/shared";
import { Options, Vue } from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Options({})
export default class extends Vue {
  @Prop({ type: Object })
  invitations?: Array<User>;

  @Prop({ type: Boolean })
  loading?: boolean;
}
</script>

<style lang="scss"></style>
